import {
  IAdapterConfig,
  MiddlewareConfigClass
} from '@care-portals/api-interfaces';

const config = {
  wellsync: {
    label: 'WellSync',
    functions: {
      createOrder: {
        version: 2,
        label: 'Create Order in WellSync',
        middlewareHandler: 'wellsync',
        passPayload: true,
        pipelines: ['order']
      },
      updateOrderWithPrescriptionStatus: {
        version: 2,
        label: 'Update Order with Prescription Status',
        middlewareHandler: 'wellsync',
        passPayload: true,
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      }
    }
  }
} as const;

export const WellSyncConfig: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type WellSyncFunctionConfiguration = MiddlewareConfigClass<
  typeof config.wellsync.functions
>;
